import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PasswordViewerDirective } from 'src/app/directives/password-viewer/password-viewer.directive';

@Component({
    selector: 'app-password-toggle-button',
    imports: [
    MatIconModule,
    MatButtonModule
],
    templateUrl: './password-toggle-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./password-toggle-button.component.scss']
})
export class PasswordToggleButtonComponent {
  @Input() passwordViewer!: PasswordViewerDirective;

  /**
   * Toggle the password visibility
   */
  toggleVisibility(): void {
    if (this.passwordViewer) {
      this.passwordViewer.toggle();
    }
  }
}
